import { Route,Routes,useNavigate,useLocation } from 'react-router-dom'
import { history } from './utils/history'

// Layouts
import AuthLayout from './layouts/AuthLayout'
import AppLayout from './layouts/AppLayout'

// Screens
import SplashScreen from './screens/SplashScreen/SplashScreen'
// Auth
import Login from './screens/Auth/Login'
import Register from './screens/Auth/Register'
import Verify from './screens/Auth/Verify'
import ScanQrCode from './screens/Auth/Scan'
import FastPayment from './screens/Auth/FastPayment'
// App
import Home from './screens/Home/Home'
// Services
import Businesses from './screens/Home/Businesses/Businesses'
import BusinessesServices from './screens/Home/BusinessesServices/BusinessesServices'
// Segments
import Segments from './screens/Home/Children/ChildSegments'
// Settings
import Settings from './screens/Settings'
// Pages
import Others from './screens/Others/Others'
import AboutUs from './screens/Others/AboutUs'
import ContactUs from './screens/Others/ContactUs'
import Callback from './screens/Home/Callback/Callback'
import Vision from './screens/Others/Vision'
import Strategy from './screens/Others/Strategy'
import Mission from './screens/Others/Mission'
import Rules from './screens/Others/Rules'
import Support from './screens/Others/Support'
import Faq from './screens/Others/Faq'
import Favorits from './screens/Others/Favorits'
import Scan from './screens/Others/Scan'
import Versions from './screens/Others/Versions'
// Children
import Children from './screens/Home/Children/Children'
import AddChildren from './screens/Home/Children/AddChildren'
import EditChildren from './screens/Home/Children/EditChildren'
import ChildrenSegments from './screens/Home/Children/ChildrenSegments'
import AddChildrenSegments from './screens/Home/Children/AddChildrenSegments'
// Basket
import Basket from './screens/Orders/Basket'
import BasketAddress from './screens/Orders/Confirm'
// Profile
import Addresses from './screens/Home/Addresses/Addresses'
import AddAddress from './screens/Home/Addresses/AddAddress'
import EditAddress from './screens/Home/Addresses/EditAddress'
// Reports
import TransactionsReports from './screens/Home/Report/Transactions'
import TransactionsChildReports from './screens/Home/Report/TransactionsChild'
// Orders
import Orders from './screens/Orders/Orders'
import Poll from './screens/Orders/Poll'
// Payment
import Payment from './screens/Home/Payment'
// Tickets
import TicketsIndex from './screens/Home/Tickets/Index'
import TicketsCreate from './screens/Home/Tickets/Create'
import TicketsView from './screens/Home/Tickets/View'

const App = () => {

  history.navigate = useNavigate()
  history.location = useLocation()

  const theme = localStorage.getItem('theme') || 'light'
  if(theme == 'light' || theme == 'dark')
      document.body.className = theme
  else{
      if(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
          document.body.className = 'dark';
      else
          document.body.className = 'light';
  }

  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="auth" element={<AuthLayout />} >
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="verify" element={<Verify />} />
        <Route path="scan" element={<ScanQrCode />} />
        <Route path="fast-payment" element={<FastPayment />} />
      </Route>
      <Route path="app" element={<AppLayout />}>
        <Route path="/app" element={<Home />} />
        <Route path="payment" element={<Payment />} />
        <Route path="businesses/:guildId" element={<Businesses />} />
        <Route path="businesses/services/:businessId" element={<BusinessesServices />} />
        <Route path="segments" element={<Segments />} />
        <Route path="settings/:guid?" element={<Settings />} />
        <Route path="others" element={<Others />} />
        <Route path="others/about" element={<AboutUs />} />
        <Route path="others/contact-us" element={<ContactUs />} />
        <Route path="others/vision" element={<Vision />} />
        <Route path="others/strategy" element={<Strategy />} />
        <Route path="others/mission" element={<Mission />} />
        <Route path="others/support" element={<Support />} />
        <Route path="others/rules" element={<Rules />} />
        <Route path="others/faq" element={<Faq />} />
        <Route path="others/favorites" element={<Favorits />} />
        <Route path="others/qrcode" element={<Scan />} />
        <Route path="others/version-info" element={<Versions />} />
        <Route path="callback/:guid?" element={<Callback />} />
        <Route path="children" element={<Children />} />
        <Route path="children/add" element={<AddChildren />} />
        <Route path="children/edit/:childId" element={<EditChildren />} />
        <Route path="children/:childId/segments" element={<ChildrenSegments />} />
        <Route path="children/:childId/segments/add" element={<AddChildrenSegments />} />
        <Route path="orders/:orderId?" element={<Orders />} />
        <Route path="orders/poll/:pollId/:serviceConsumerId" element={<Poll />} />
        <Route path="basket" element={<Basket />} />
        <Route path="basket/confirm/:orderId?/:repay?" element={<BasketAddress />} />
        <Route path="profile/addresses" element={<Addresses />} />
        <Route path="profile/addresses/add" element={<AddAddress />} />
        <Route path="profile/addresses/:id" element={<EditAddress />} />
        <Route path="reports/transactions/:id?" element={<TransactionsReports />} />
        <Route path="reports/child-transactions/:id?" element={<TransactionsChildReports />} />
        <Route path="tickets" element={<TicketsIndex />} />
        <Route path="tickets/add" element={<TicketsCreate />} />
        <Route path="tickets/:id" element={<TicketsView />} />
      </Route>
    </Routes>
  )
}

export default App